import { Skeleton } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

const LiveCardSkeleton = () => {
  const screens = useBreakpoint();

  return (
    <div className='w-full lg:min-w-[432px] border border-[#282829] text-white rounded-xl overflow-hidden shadow-lg bg-black flex flex-col'>
      <div className='relative w-full h-full max-h-[140px] md:max-h-[218px] aspect-[2/1]'>
        <Skeleton.Button active className='w-full h-full !rounded-none' />
      </div>

      <div className='p-3 md:p-7 flex flex-col gap-3'>
        <Skeleton.Button
          active
          style={{
            width: 100,
            height: 24,
            borderRadius: 8,
          }}
        />

        <Skeleton.Input
          active
          style={{
            width: '80%',
            height: screens.md ? 28 : 22,
          }}
        />

        <Skeleton.Input
          active
          style={{
            width: '70%',
            height: 20,
          }}
        />

        <div className='flex items-start gap-3 mt-2 md:mt-4'>
          <Skeleton.Avatar active size={screens.md ? 48 : 40} shape='circle' />
          <div className='flex-1 flex flex-col gap-2'>
            <Skeleton.Button
              active
              style={{
                width: 160,
                height: 24,
                borderRadius: 20,
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: '60%',
                height: 20,
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: '80%',
                height: 18,
              }}
            />
          </div>
        </div>

        <Skeleton.Button
          active
          className='w-full'
          style={{
            height: 36,
            borderRadius: 8,
          }}
        />
      </div>
    </div>
  );
};

export default LiveCardSkeleton;
